module.exports = __webpack_public_path__ + "img/hc.37e9120b.png";